import "react-app-polyfill/ie9";
import "./assets/polyfills/append";

import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import ReactGA from "react-ga";
import { historyMiddleware } from "./middlewares/history";
import { trackingMiddleware } from "./middlewares/tracking";
import { initialState } from "./state";
import {
  applyProviderConfigurations,
  getFromQueryString,
} from "./actions/services.js";
import "./assets/styles/app.css";

import App from "./containers/OscApp";
import reducer from "./reducers/session";
import registerServiceWorker from "./registerServiceWorker";

import TagManager from 'react-gtm-module';

ReactGA.initialize(window.settings.ga.account, {
  debug: window.settings.ga.debug,
});

window.provider =
  getFromQueryString("provider") ||
  sessionStorage.getItem("provider") ||
  "default";
window.isCalProvider = window.provider == "default" || null ? true : false;

sessionStorage.setItem("provider", window.provider);

window.hidenavbar =
  getFromQueryString("hidenavbar") ||
  sessionStorage.getItem("hidenavbar") ||
  false;
sessionStorage.setItem("hidenavbar", window.hidenavbar);

window.returnAppUrl =
  decodeURIComponent(getFromQueryString("returnAppUrl")) ||
  sessionStorage.getItem("returnAppUrl") ||
  false;
sessionStorage.setItem("returnAppUrl", window.returnAppUrl);

window.partnerId =
  decodeURIComponent(getFromQueryString("partnerId")) ||
  sessionStorage.getItem("partnerId") ||
  null;
sessionStorage.setItem("partnerId", window.partnerId);

applyProviderConfigurations(window.provider);

export const store = createStore(
  reducer,
  {},
  applyMiddleware(historyMiddleware, trackingMiddleware)
);

const tagManagerArgs = {
  gtmId: window.settings.gtmKey, // Replace with your GTM container ID
  //gtmId : "GTM-WBPWX8CR"
};
TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js